
<template>
  <div class="x-button">
    <div>999</div>
  </div>
</template>
<script>
export default {
  name: 'XButton',
  props: {

  }

}
</script>

<style scoped>
  .x-button {
      display: inline-block;
      padding: 3px 6px;
      background: green;
      color: #fff;
  }
</style>
